import { Component, ElementRef, HostListener } from '@angular/core'
import { CurrentProductService, ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { BehaviorSubject } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { EbFormConfig } from '../../../form/interfaces/eb-form.interface'
import { EbFavoritesService } from '../../services/facades/eb-favorites.service'

@Component({
    selector: 'eb-favorites-create-dialog',
    templateUrl: './eb-favorites-create-dialog.component.html',
    styleUrls: ['./eb-favorites-create-dialog.component.scss'],
    standalone: false
})
export class EbFavoritesCreateDialogComponent {
  iconTypes = ICON_TYPE

  callback: CallableFunction

  formConfig: EbFormConfig = {
    steps: [
      {
        hideTitle: true,
        elements: [
          {
            name: 'name',
            type: 'field',
            fieldType: 'input',
            value: '',
            required: true
          }
        ]
      }
    ],
    stepsAlwaysEnabled: true
  }

  submitting$ = new BehaviorSubject(false)

  constructor(
    protected modalService: LaunchDialogService,
    protected favoritesService: EbFavoritesService,
    protected currentProductService: CurrentProductService,
    protected el: ElementRef
  ) {}

  onSubmit(form) {
    this.submitting$.next(true)
    this.currentProductService
      .getProduct()
      .pipe(
        take(1),
        switchMap(product => {
          return this.favoritesService.createFavorites(form.name, product?.code).pipe(take(1))
        })
      )
      .subscribe(() => {
        this.submitting$.next(false)
        this.dismissModal('new favorites created')
      })
  }

  dismissModal(reason?: any): void {
    this.modalService.closeDialog(reason)
  }
  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.dismissModal('Cross click')
    }
  }
}
